// CarDetailsPage.jsx
import { useParams } from 'react-router-dom';
import { useCarDetails } from '../../hooks/useCarDetails';
import CarDetailsPageClient from './CarDetailsPageClient';
import { useTranslation } from '../../hooks/useTranslation';

export default function CarDetailsPage() {
  const { t } = useTranslation();
  const { slug } = useParams();
  const { carData, loading, error } = useCarDetails(slug);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error || !carData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-500 mb-4">{t('extra.error_loading')}</h2>
          <p className="text-gray-600">{t('extra.try_refresh')}</p>
        </div>
      </div>
    );
  }

  return <CarDetailsPageClient carData={carData} />;
}
